import { useQueryUserLibraryEquipmentType } from '@ifit/gateway-wolf-athenaeum-service';
import {
  useInfiniteQueryOptions,
  useBasicAuthWithCacheOptions,
} from '../query-options';

export const useEquipmentType = () => {
  const opts = {
    ...useBasicAuthWithCacheOptions(),
    ...useInfiniteQueryOptions(),
  };

  const { data, isLoading } = useQueryUserLibraryEquipmentType(opts);
  return { equipmentType: data?.equipmentType, isLoading };
};
